// ==========================================
// PORTFOLIO DATA - Edit your content here!
// ==========================================

export const personalInfo = {
  name: "Dhruv Singh",
  title: "Degree: B.tech AI/ML",
  description: "My goal is to create technology that not only solves today’s challenges but also shapes the future of how financial businesses operate.",
  email: "dmsworlds@gmail.com",
  phone: "+91 7738198960",
  linkedin: "https://linkedin.com/in/dhruv-singh-35070a24b",
  github: "https://github.com/dhruv1122",
};

export const projects = [
  {
    id: 1,
    title: "DataMind",
    description: "A smart AI-based data analysis system currently deployed in a company. Performs intelligent analysis on databases to extract meaningful information and generate actionable insights for business decision-making.",
    tech: ["Python", "AI/ML", "NLP", "SQL", "Data Analysis"],
    metrics: [""],
    status: "In Production",
    featured: true,
    link: "ai.ftspl.in:81", // Add your project link here
  },
  {
    id: 2,
    title: "FinBot",
    description: "AI-based stock analysis tool for Indian markets. Ask questions in English or Hindi about stocks and get instant analysis.",
    tech: ["Python", "AI/ML", "NLP", "Finance API"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "https://github.com/dhruv1122/FINBOT",
  },
  {
    id: 3,
    title: "Smart OCR Invoice System",
    description: "Intelligent invoice processing using FastAPI and Qwen2vl-7B LLM that extracts data into standardized JSON format.",
    tech: ["FastAPI", "Qwen2vl-7B", "Python", "Computer Vision"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "https://github.com/dhruv1122/invoice_extractor",
  },
  {
    id: 4,
    title: "Integrated QR System",
    description: "Dynamic QR generator with one-time use codes, selective information encoding and secure sharing.",
    tech: ["Python", "React", "Supabase"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "#https://github.com/dhruv1122/qr_scanner",
  },
  {
    id: 5,
    title: "AI Image Generator",
    description: "Web-based creative tool using Flux LLM that enables AI-powered image generation through an intuitive interface.",
    tech: ["TypeScript", "Flux LLM", "CSS"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "https://github.com/dhruv1122/image_gen",
  },
  {
    id: 6,
    title: "Multi-Input Language Translator",
    description: "Versatile translation system using Llama LLM with text, voice, and file inputs supporting 10+ languages.",
    tech: ["Llama LLM", "NLP", "Python", "Voice Processing"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "#",
  },
  {
    id: 7,
    title: "Hawk-Bot",
    description: "In-terminal simulation connected to Cardano blockchain for tracking new pool formation across all DEXs.",
    tech: ["Python", "Cardano", "Blockchain", "DEX"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "https://github.com/dhruv1122/hawk_bot",
  },
  {
    id: 8,
    title: "Ghost Stealth Buyer",
    description: "Application for invisible token purchases on Cardano, enabling discreet blockchain transactions.",
    tech: ["Python", "Cardano", "Smart Contracts", "DeFi"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "https://github.com/dhruv1122/ghost_stealth_buyer",
  },
  {
    id: 9,
    title: "Whale Tracker",
    description: "Real-time monitoring of whale movements in Cardano blockchain, tracking large transactions and wallet activities.",
    tech: ["Python", "Cardano", "Blockchain Analytics"],
    metrics: [""],
    status: "Completed",
    featured: false,
    link: "https://github.com/dhruv1122/whale_tracker",
  },
];

export const skills = [
  { name: "Python", highlight: false },
  { name: "JavaScript", highlight: false },
  { name: "React", highlight: false },
  { name: "AI/ML", highlight: true },
  { name: "FastAPI", highlight: false },
  { name: "TypeScript", highlight: false },
  { name: "PyTorch", highlight: true },
  { name: "Node.js", highlight: false },
  { name: "TensorFlow", highlight: true },
  { name: "Java", highlight: false },
  { name: "NLP", highlight: true },
  { name: "SQL", highlight: false },
];

export const about = {
  background: `I am a B.Tech graduate in Artificial Intelligence and Machine Learning with hands-on experience as an AI Developer and Sales Portal Analyst. I specialize in Python, Machine Learning, and Large Language Models (LLMs), and I enjoy building data-driven solutions that create measurable business impact.

Along with my work in AI, I am actively expanding my skills toward Quantitative Finance and High-Frequency Trading (HFT). I am currently strengthening my foundations in probability, statistics, time-series modeling, algorithmic trading concepts, and Python for quant development.

I am seeking opportunities where I can combine my AI background with quantitative research, model development, and algorithmic trading to build fast, optimized, and intelligent systems.`,
  
  goals: [
    'Building AI tools that enhance financial analysis, forecasting, and decision-making',
    'Streamlining financial operations through automation, optimization, and intelligent workflows',
    'Bridging the gap between cutting-edge AI research and real-world financial applications',
  ],
};

export const navLinks = [
  { name: "Overview", href: "#" },
  { name: "Projects", href: "#projects" },
  { name: "Skills", href: "#skills" },
  { name: "Contact", href: "#contact" },
];
